import {themeSpacing} from '../constants';

const MuiPopover = {
    styleOverrides: {

        paper: {
            borderRadius: themeSpacing[2] + "px",
        }
    },
};
export default MuiPopover;